import { render, staticRenderFns } from "./MoleculeCertifications.vue?vue&type=template&id=c2246b2c&scoped=true&"
import script from "./MoleculeCertifications.vue?vue&type=script&lang=js&"
export * from "./MoleculeCertifications.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeCertifications.vue?vue&type=style&index=0&id=c2246b2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2246b2c",
  null
  
)

export default component.exports